import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client";

/** Raw lead from /api/lead-inbox. GET отдаёт результат D1 `{ results: [...] }` (15.10: раньше ждали голый массив — вкладка всегда была пустой). */
export interface Lead {
  id: string | number;
  client_name?: string | null;
  phone?: string | null;
  players?: number | null;
  comment?: string | null;
  telegram?: string | null;
  expected_revenue?: number | null;
  source?: string | null;
  created_by_name?: string | null;
  status?: string | null;
  created_at?: string | null;
}

export function useLeadInbox() {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [trigger, setTrigger] = useState(0);
  const reload = useCallback(() => setTrigger((n) => n + 1), []);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    api<Lead[] | { results?: Lead[] }>("/api/lead-inbox")
      .then((rows) => {
        if (!alive) return;
        setLeads(Array.isArray(rows) ? rows : Array.isArray(rows?.results) ? rows.results : []);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (!alive) return;
        setError(e instanceof Error ? e.message : "Не удалось загрузить лиды");
        setLoading(false);
      });
    return () => { alive = false; };
  }, [trigger]);

  /* 15.10: заявки с сайта приходят круглосуточно — список сам обновляется раз в минуту, пока приложение на экране */
  useEffect(() => {
    const t = window.setInterval(() => { if (document.visibilityState === "visible") reload(); }, 60000);
    return () => window.clearInterval(t);
  }, [reload]);

  return { leads, loading, error, reload };
}
